// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import building07Icon from "@/assets/icons/building-07.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type Building07IconProps = Omit<IconProps, "name">;

export function Building07Icon(props: Building07IconProps): React.ReactNode {
  return <Icon name={building07Icon} {...props} />;
}
